<template>
	<div class="my-details-view">
		<div class="my-details-view__header">
			<h2 class="common__heading bottom-gap-lg">My Details</h2>

			<router-link
				class="btn btn--secondary btn--sm bottom-gap-sm my-details-view__btn"
				:to="{name: 'updateDetails'}"
				v-show="hasUsername"
			>Edit Details</router-link>

			<router-link
				class="btn btn--secondary btn--sm bottom-gap-sm my-details-view__btn my-details-view__hide"
				:class="{'is-disabled': disabledEdit}"
				:to="{name: 'changeEmail'}"
				v-show="hasUsername"
			>Change Email</router-link>
		</div>

		<div class="o-grid my-details-view__container">
			<div class="o-grid__item o-1/2@largeTablet o-1/3@desktop">
				<div class="my-details-view__label">Name</div>
				<div class="my-details-view__value">{{ checkedUser.given_name }} {{ checkedUser.family_name }}</div>
			</div>
		<div class="o-grid__item o-2/3@largeTablet o-2/4@desktop">
				<div class="my-details-view__label">Email</div>
				<div class="my-details-view__value">{{ checkedUser.email }}</div>
			</div>

			<div class="o-grid__item o-1/2@largeTablet o-1/3@desktop" v-if="checkedUser.displaymobilephone && checkedUser.mobilephone != ''">
				<div class="my-details-view__label">Mobile Number</div>
				<div class="my-details-view__value">{{ checkedUser.mobilephone }}</div>
			</div>

			<div class="o-grid__item o-2/3@largeTablet o-2/4@desktop" v-if="checkedUser.displayaddress && formatAddress != ''">
				<div class="my-details-view__label">Address</div>
				<div class="my-details-view__value" v-html="formatAddress"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';

	export default {
    props: {
      user: {
        type: Object
      }
    },
    data() {
      return {
        hasUsername: false
      }
    },
    computed: {
      checkedUser() {
        if (this.user) {
          return this.user;
        } else {
          return {};
        }
      },
      disabledEdit() {
        return this.checkedUser.identities && this.checkedUser.identities.length;
      },
      formatAddress() {
        let addr = this.checkedUser.address1_line1;
        if (this.checkedUser.address1_line2 != '') addr = addr + '<br/>' + this.checkedUser.address1_line2;
        if (this.checkedUser.address1_city != '') addr = addr + '<br/>' + this.checkedUser.address1_city;
        if (this.checkedUser.address1_stateorprovince != '') addr = addr + ' ' + this.checkedUser.address1_stateorprovince;
        if (this.checkedUser.address1_postalcode != '') addr = addr + ' ' + this.checkedUser.address1_postalcode;
        if (this.checkedUser.address1_country != '') addr = addr + '<br/>' + this.checkedUser.address1_country;
        return addr;
      }
    },
    mounted() {
      if (this.user && this.user.username) this.hasUsername = true;
    }
  };
</script>

<style lang="scss" scoped>
	@import '~sass/_variables.scss';
	@import "~sass/_config.scss";
	@import "~sass/mixins/_media-query.scss";

	.my-details-view {
    font-family: $font-1;

    &__label {
      font-size: 14px;
      line-height: 16px;
      color: $col-neutral--6;
    }

    &__value {
      font-size: 18px;
      line-height: 22px;
      color: $col-neutral--8;
      font-weight: 600;
    }

    &__hide {
      display: none;
    }

    @include mq(largeTablet) {
      &__header {
        display: flex;
        align-items: flex-start;
      }

      &__btn {
        margin-left: 5px;

        &:first-of-type {
          margin-left: auto;
        }
      }

      &__hide {
        display: none;
      }

      &__label {
        font-size: 16px;
        line-height: 19px;
      }

      &__value {
        font-size: 20px;
        line-height: 27px;
      }
    }
  }
</style>
